export default __webpack_public_path__ + "static/media/XS4 Mini.6210b1e0.jpg";